export default __webpack_public_path__ + "static/media/img14.7aab3588.jpg";